import { useState, useEffect } from "react";
import queryString from "query-string";
import { Button } from "@components";
import { LinkDocument } from "@components";
import { ReportAPINew } from "@api";
import moment from "moment";
import "./FinancialReport.scss";
import { useTranslation } from "react-i18next";

function FinancialReportTriwulan() {
  const {t} = useTranslation();
  const [yearCollection, setYearCollection] = useState();
  const [financialReport, setFinancialReport] = useState();
  const [loadFinancialReport, setLoadFinancialReport] = useState(false);

  useEffect(() => {
    const getFinancialReport = async (year) => {
      const filter = {
        cat: "laporan_keuangan",
        orderBy: "asc",
        from: `${year-1}-12-31`,
        to: `${year}-12-30`,
        perPage: 100,
      };
      const { data } = await ReportAPINew(queryString.stringify(filter));      
      setFinancialReport(data.data != null ? data.data.result : []);
    };
    const getYearCollection = () => {
      const currentYear = new Date().getFullYear();
      let collection = [];

      for (let x = currentYear - 5; x < currentYear; x++) {
        collection.push({
          year: x,
          selected: false,
        });
      }

      collection.push({
        year: currentYear,
        selected: true,
      });

      setYearCollection(collection);
      getFinancialReport(currentYear);
    };

    if (!yearCollection) {
      getYearCollection();
    }

    if (loadFinancialReport) {
      getFinancialReport(
        yearCollection.filter((data) => data.selected)[0].year
      );
    }
  }, [yearCollection, loadFinancialReport]);

  const selectYear = (year) => {
    setYearCollection(
      yearCollection.map((data) => {
        return { ...data, ...{ selected: year === data.year } };
      })
    );
    setLoadFinancialReport(true);
  };

  const filterByMonth = (start, end) => {
    const data = !!financialReport
      ? financialReport.filter((data) => {
          const month = moment(data.created_date, "DD-MM-YYYY hh:mm:ss").format(
            "M"
          );
          if (month >= start && month <= end) {
            return true;
          }
          return false;
        })
      : [];
    return data;
  };

  return (
    <div className="financial-report-tab-section">
      <div className="filter-box">
        <div className="title">{t("pilih_tahun")}</div>
        <div className="filter-list">
          {!!yearCollection
            ? yearCollection.map((value, i) => {
                return (
                  <Button
                    label={value.year}
                    selected={value.selected}
                    key={i}
                    onClick={() => selectYear(value.year)}
                  />
                );
              })
            : ""}
        </div>
      </div>
      <div>
        <div className="accordion-box">
          <div className="accordion" id="TriwulanI">
            <div className="accordion-item">
              <h2
                className="accordion-header"
                id="panelsStayOpen-headingTriwulanI"
              >
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTriwulan1"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTriwulan1"
                >
                  {t("triwulan")} I
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTriwulan1"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTriwulanI"
              >
                <div className="accordion-body">
                  <div className="card-link">
                    {filterByMonth(1, 3).map((data, i) => {
                      return (
                        <LinkDocument
                          label={moment(
                            data.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("DD MMMM YYYY")}
                          title={data.title}
                          linkRedirect={data.file}
                          key={i}
                        />
                      );
                    })}
                    {filterByMonth(1, 3).length > 0 ? (
                      ""
                    ) : (
                      <div className="card-link-empty">
                        <p>{t("data_tidak_tersedia")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-box">
          <div className="accordion" id="TriwulanII">
            <div className="accordion-item">
              <h2
                className="accordion-header"
                id="panelsStayOpen-headingTriwulanII"
              >
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTriwulan2"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTriwulan2"
                >
                  {t("triwulan")} II
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTriwulan2"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTriwulanII"
              >
                <div className="accordion-body">
                  <div className="card-link">
                    {filterByMonth(4, 6).map((data, i) => {
                      return (
                        <LinkDocument
                          label={moment(
                            data.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("DD MMMM YYYY")}
                          title={data.title}
                          linkRedirect={data.file}
                          key={i}
                        />
                      );
                    })}
                    {filterByMonth(4, 6).length > 0 ? (
                      ""
                    ) : (
                      <div className="card-link-empty">
                        <p>{t("data_tidak_tersedia")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-box">
          <div className="accordion" id="TriwulanIII">
            <div className="accordion-item">
              <h2
                className="accordion-header"
                id="panelsStayOpen-headingTriwulanIII"
              >
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTriwulan3"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTriwulan3"
                >
                  {t("triwulan")} III
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTriwulan3"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTriwulanIII"
              >
                <div className="accordion-body">
                  <div className="card-link">
                    {filterByMonth(7, 9).map((data, i) => {
                      return (
                        <LinkDocument
                          label={moment(
                            data.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("DD MMMM YYYY")}
                          title={data.title}
                          linkRedirect={data.file}
                          key={i}
                        />
                      );
                    })}
                    {filterByMonth(7, 9).length > 0 ? (
                      ""
                    ) : (
                      <div className="card-link-empty">
                        <p>{t("data_tidak_tersedia")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-box">
          <div className="accordion" id="TriwulanIV">
            <div className="accordion-item">
              <h2
                className="accordion-header"
                id="panelsStayOpen-headingTriwulanIV"
              >
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTriwulan4"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTriwulan4"
                >
                  {t("triwulan")} IV
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTriwulan4"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTriwulanIV"
              >
                <div className="accordion-body">
                  <div className="card-link">
                    {filterByMonth(10, 12).map((data, i) => {
                      return (
                        <LinkDocument
                          label={moment(
                            data.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("DD MMMM YYYY")}
                          title={data.title}
                          linkRedirect={data.file}
                          key={i}
                        />
                      );
                    })}
                    {filterByMonth(10, 12).length > 0 ? (
                      ""
                    ) : (
                      <div className="card-link-empty">
                        <p>{t("data_tidak_tersedia")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinancialReportTriwulan;
